import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { Router, Route,browserHistory} from 'react-router';
import thunk from 'redux-thunk';
import reducers from './reducers';
import ReactGA from 'react-ga';
// My GA ID:: UA-91206053-1
ReactGA.initialize('UA-87061138-3');
import $ from 'jquery';
const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
const store = createStoreWithMiddleware(reducers);
import App from './components/App';
import Home from './components/Home/Home.js';
import Login from './components/Auth/login';
import Registration from './components/Auth/Registration';
import Otpverify from './components/Auth/Otpverify';
import verifyOtp from './components/Auth/verifyOtp.js';
import Reset from './components/Auth/reset.js';
import Ab_Login from './components/Auth/ab_login.js';
import Signup from './components/Auth/Signup';
import Profile from './components/Auth/profile.js';
import SeedsList from './components/Categories/Seed/SeedsList.js';
import SeedsCat from './components/Categories/Seed/SeedsCat.js';
import SeedDetails from './components/Categories/Seed/SeedDetails.js';
import BrowseFeedDeals from './components/Categories/Feed/Browse_feed_deals.js';
import SubDeals from './components/Categories/Feed/subdeals.js';
import ProductFullDetails from './components/Categories/Feed/product_full_details.js';
import ProductDetails from './components/Categories/Feed/pdeals.js';
import OffersDetails from './components/Categories/Feed/offers_details.js';
import Search from './components/Categories/Common/Search';
import EnquireNow from './components/Categories/Common/Enquire_now';
import EnquireNow_Partner from './components/Categories/Common/EnquireNow_Partner.js';
import CustomerCare from './components/Categories/Common/Customer_care';
import CustomerCare_Seller from './components/Categories/Common/customer_care_seller.js';
import NotFound from './components/Categories/Common/NotFound.js';
import Coupon_Details from './components/Categories/Coupons/coupon_details.js';
import PromoOffersZone from './components/Categories/Common/promo_offerszone.js';
import PromoOfr_Details from './components/Categories/Common/promo_offers_fulldetails.js';
import ChangeNumber from './components/Auth/change_number.js';
import ChangeVerifyOtp from './components/Auth/ChangeVerifyOtp.js';
import NaupliiDeals from './components/Categories/Seed/NaupliiDeals.js';
import MyCart from './components/Categories/Cart/MyCart.js';
import MobileNumber from './components/Auth/mob_num.js';
import MobVerifyOtp from './components/Auth/mob_verify_otp.js';
import AllPromoOffers from './components/Categories/Common/AllPromoOffers.js';
import StoreDeals from './components/Categories/Stores/store_deals.js';
import Share_Earn from './components/Categories/Common/Share_Earn.js';
import MyAquaCash from './components/Categories/Accounts/My_Aquacash.js';
import Checkout from './components/Categories/Cart/Checkout.js';
import My_Orders from './components/Categories/Orders/My_Orders.js';
import Order_Details from './components/Categories/Orders/Order_Details.js';
import Order_response from './components/Categories/Cart/Order_response.js';
import Order_aborted from './components/Categories/Cart/Order_aborted.js';
import My_Order_aborted from './components/Categories/Orders/My_Order_aborted.js';
import Notifications from './components/Categories/Accounts/Notifications.js';
import View_Rating from './components/Categories/Accounts/View_Rating.js';
import GiveRatings from './components/Categories/Accounts/GiveRatings.js';
import downloads from './components/Categories/Common/downloads.js';
import QuickCart from './components/Categories/Cart/QuickCart.js';
import Shipping_Payment from './components/Categories/Orders/Shipping_Payment.js';
import Shipping_Status from './components/Categories/Orders/Shipping_Status.js';
import Quick_Checkout from './components/Categories/Cart/Quick_Checkout.js';
import WishList from './components/Categories/WishList/WishList.js';
import SmartCart from './components/Categories/SmartCart/SmartCart.js';
import About_Brand from './components/Categories/Brands/About_Brand.js';
import PartnerDeals from './components/Categories/Stores/PartnerDeals.js';
import Advertise from './components/Categories/Common/Advertise.js';
import SiteMap from './components/Categories/Common/SiteMap.js';
import CheckoutFlow from './components/Categories/Common/CheckoutFlow.js';
 
import './assets/css/bootstrap.css';
import './assets/css/style.css';
import './assets/css/custom.css';
import './assets/css/offcanvas.min.css';
import './assets/css/icons-style.css';
import './assets/css/new_style.css';
import './assets/fonts/digital.ttf';

// Desktop WEB IMPORTS STARTS HERE
import './Desktop/assets/css/bootstrap.min.css';

import './Desktop/assets/css/custom.css';
import './Desktop/assets/css/style.css';
import './Desktop/assets/css/font_icons.css';
import './Desktop/assets/css/newstyles.css';
// import './Desktop/assets/css/icons-style.css';

import './Desktop/assets/css/style_web.css';
import './Desktop/assets/css/style_web2.css';

import Web_IndexHome from './Desktop/components/Home/Web_IndexHome.js';
import Web_SeedsList from './Desktop/components/Seed/Web_SeedsList.js';
import Web_Seed_Details from './Desktop/components/Seed/Web_Seed_Details.js';
import Web_ProductDetails from './Desktop/components/Feed/Web_pdeals.js';
import Web_ProductFullDetails from './Desktop/components/Feed/Web_product_full_details.js';
import Web_SubDeals from './Desktop/components/Feed/Web_subdeals.js';
import Web_App from './Desktop/Web_App.js';
import Web_EnquireNow from './Desktop/components/Common/Web_enquire_now.js';
import Web_CustomerCare from './Desktop/components/Common/Web_customer_care';
import Web_CustomerCare_Seller from './Desktop/components/Common/Web_customer_care_seller.js';
import Web_Registration from './Desktop/components/Auth/Web_Registration.js';
import Web_Login from './Desktop/components/Auth/Web_login.js';
import Web_Forgot from './Desktop/components/Auth/Web_forgot.js';
import Web_Ab_Login from './Desktop/components/Auth/Web_ab_login.js';
import Web_verifyOtp from './Desktop/components/Auth/Web_verifyOtp.js';
import Web_Signup from './Desktop/components/Auth/Web_Signup.js';
import Web_Reset from './Desktop/components/Auth/Web_reset';
import Web_Coupon_Details from './Desktop/components/Coupons/Web_coupon_details.js';
import Web_Profile from './Desktop/components/Accounts/Web_Profile.js';
import Web_Otpverify from './Desktop/components/Auth/Web_Otpverify.js';
import Web_MobileNumber from './Desktop/components/Auth/Web_mob_num.js';
import Web_MobVerifyOtp from './Desktop/components/Auth/Web_mob_verify_otp.js';
import Web_EnquireNow_Partner from './Desktop/components/Common/Web_EnquireNow_Partner.js';
import Web_OffersDetails from './Desktop/components/Feed/Web_OffersDetails.js';
import Web_PromoOffersZone from './Desktop/components/Common/Web_promo_offerszone.js';
import Web_MyCart from './Desktop/components/Cart/Web_MyCart.js';
import Web_NaupliiDeals from './Desktop/components/Seed/Web_NaupliiDeals.js';
import WebdealBlocks from './Desktop/components/Common/Web_DealBlocks.js';
import Web_AllPromoOffers from './Desktop/components/Common/Web_AllPromoOffers.js';
import Web_Checkout from './Desktop/components/Cart/Web_Checkout.js';
import Web_Order_aborted from './Desktop/components/Cart/Web_Order_aborted.js';
import Web_Order_response from './Desktop/components/Cart/Web_Order_response.js';
import Web_downloads from './Desktop/components/Common/Web_downloads.js';
import Web_Shipping_Payment from './Desktop/components/Orders/Web_Shipping_Payment.js';
import Web_Shipping_Status from './Desktop/components/Orders/Web_Shipping_Status.js';
import Web_Order_Details from './Desktop/components/Orders/Web_Order_Details.js';
import Web_View_Rating from './Desktop/components/Accounts/Web_View_Rating.js';
import Web_GiveRatings from './Desktop/components/Accounts/Web_GiveRatings.js';
import Web_My_Orders from './Desktop/components/Orders/Web_My_Orders.js';
import Web_My_Order_aborted from './Desktop/components/Orders/Web_My_Order_aborted.js';
import Web_QuickCart from './Desktop/components/QuickCart/Web_QuickCart.js';
import Web_Quick_Checkout from './Desktop/components/QuickCart/Web_Quick_Checkout.js';
import Web_Store_Deals from './Desktop/components/Stores/Web_Store_Deals.js';
import Web_Change_Number from './Desktop/components/Auth/Web_Change_Number.js';
import Web_ChangeVerifyOtp from './Desktop/components/Auth/Web_ChangeVerifyOtp.js';
import Web_Share_Earn from './Desktop/components/Common/Web_Share_Earn.js';
import Web_MyAquaCash from './Desktop/components/Accounts/Web_My_Aquacash.js';
import Web_Notifications from './Desktop/components/Accounts/Web_Notifications.js';
import Web_PromoOfr_Details from './Desktop/components/Common/Web_Promo_Offers_Fulldetails.js';
import WebPromotions from './Desktop/components/Promotions/WebPromotions.js';
import Web_SmartCart from './Desktop/components/SmartCart/Web_SmartCart.js';
import Web_WishList from './Desktop/components/WishList/Web_WishList.js';
import Web_About_Brand from './Desktop/components/Brands/Web_About_Brand.js';

import Web_Partner_Deals from './Desktop/components/Stores/Web_Partner_Deals.js';
import Web_Advertise from './Desktop/components/Common/Web_Advertise.js';
import Web_Site_Map from './Desktop/components/Common/Web_Site_Map.js';
import Web_Site_CheckoutFlow from './Desktop/components/Common/Web_Site_CheckoutFlow.js';

function logPageView()
{
	ReactGA.set({ page: window.location.pathname });
	ReactGA.pageview(window.location.pathname);

	const loc = window.location;
	location.path = `${loc.search}`;
	var str = location.path;
	var str_href=`${loc.href}`;
	// var pageUrl='${loc.base}';
	var baseUrl='https://aquadeals.in/admin/web3/user/';
	var ref_url=document.referrer;
	if(str !== '' || ref_url !== '')
    {
    	localStorage.setItem('tot_url',loc);
    	// document.cookie="tot_url="+loc;
    	// document.cookie="camp="+str;
    	localStorage.setItem('camp',str)	
    	var fromName='';
    	if(localStorage.user_id)
    	{
    		var uid=localStorage.getItem('user_id');
    	}
    	else
    	{
    		 uid=0;
    	}
		if(screen.width < 800)
		{
			fromName='mobile_web';
		}
		else
		{
			fromName='desktop_web';
		}
		var data1={from:fromName,url:str_href,uid:uid,ref_url:ref_url}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'split_url',
			success:function(data)
			{
				if(data.status==='success')
				{
					localStorage.setItem('source',data.source);
					localStorage.setItem('campaign',data.campaign);
					localStorage.setItem('url_id',data.url_id);
				}
			},
			error:function(err)
			{
			}
		})
    }
}

ReactDOM.render(
<Provider store={store}>
	<Router history={browserHistory} onUpdate={logPageView} >
		<Route path="/" component={App} />
		<Route path="/aboutus" component={Home} />
		<Route path="/home" component={App}/>
 		<Route path="/account(/:redirectPath)" component={Login} />
 		<Route path="/login(/:redirectPath)" component={Registration} />
 		<Route path="/verify" component={verifyOtp} />
 		<Route path="/Otpverify" component={Otpverify} />
 		<Route path="/reset" component={Reset} />
 		<Route path="/signup" component={Signup} />
 		<Route path="/profile" component={Profile} />
 		<Route path="/seed" component={SeedsList} />
 		<Route path="/seed/:Name/:Stype" component={SeedsCat} />		
		<Route path="/sdetails/:BrandName/:Id" component={SeedDetails} />
		<Route path="/ab_login" component={Ab_Login} />
		<Route path="/subdeals/:BrandName/:CatName/:ProName/:Pid" component={SubDeals} />
		<Route path="/subdeals/:Pid" component={SubDeals} />
		<Route path="/subdeals/:BrandName/:CatName/:DType/:ProName/:Pid" component={SubDeals} />
		<Route path="/subdeals/:BrandName/:CatName/:ProName/:Pid/type/:DType" component={SubDeals} />
		<Route path="/pdeals/:BrandName/all/:Type" component={BrowseFeedDeals} />
		<Route path="/pdeals/:BrandName/:CatName/:Tid/:Type/:DType(/:Dids)" component={ProductDetails} />
		<Route path="/pdeals/:Type/:CatName/:Tid" component={ProductDetails} />
		<Route path="/pdeals/:Type/:Tid" component={PartnerDeals} />
		<Route path="/offers/deals/:Tid/:Type/:DType" component={OffersDetails} />
		<Route path="/pdetails/:Pid/:DealId" component={ProductFullDetails} />
		<Route path="/pdetails/:BrandName/:CatName/:Title/:Pid/:DealId" component={ProductFullDetails} />
		<Route path="/pdetails/:BrandName/:CatName/:Bname/:Title/:Pid/:DealId" component={ProductFullDetails} />
		<Route path="/Search" component={Search} />
		<Route path="/enquire_now/partner/support/:Sid/:Did" component={EnquireNow_Partner} />
 		<Route path="/enquire_now/:Ltype/:Sid/:Did" component={EnquireNow} />
 		<Route path="/nauplii" component={NaupliiDeals} />
		<Route path="/customer_care" component={CustomerCare} />
 		<Route path="/customer_care_seller" component={CustomerCare_Seller} />
 		<Route path="/coupon/details/:Cid" component={Coupon_Details} />
		<Route path="/offerszone" component={PromoOffersZone} />
		<Route path="/offer/:Oid/details" component={PromoOfr_Details} />	
		<Route path="/change_number" component={ChangeNumber} />
		<Route path="/verify_otp" component={ChangeVerifyOtp} />
		<Route path="/mobile" component={MobileNumber} />
		<Route path="/mobile/verify_otp" component={MobVerifyOtp} />
		<Route path="/promotional_offers" component={AllPromoOffers} />
		<Route path="/mycart" component={MyCart} />
		<Route path="/stores/:StoreType/:ID" component={StoreDeals} />
		<Route path="/stores/:StoreType" component={StoreDeals} />
		<Route path="/ad-banners/:StoreType" component={StoreDeals} />
		<Route path="/myaquacash" component={MyAquaCash} />
		<Route path="/checkout" component={Checkout} />
		<Route path="/share_earn" component={Share_Earn} />
		<Route path="/myorders" component={My_Orders} />
		<Route path="/order_details/:OrderType/:Oid" component={Order_Details} />
		<Route path="/status/:book_id/:type/:Uid" component={Order_response} />
		<Route path="/status/:Type" component={Order_aborted} />
		<Route path="/order_status/:Type" component={My_Order_aborted} />
		<Route path="/notifications" component={Notifications} />
		<Route path="/viewrating/:Bid" component={View_Rating} />
		<Route path="/viewrating/:Product/:Bid" component={View_Rating} />
		<Route path="/giverating/:Bid" component={GiveRatings} />
		<Route path="/giverating/:Product/:Bid" component={GiveRatings} />
		<Route path="/downloads" component={downloads} />
		<Route path="/quickcart" component={QuickCart} />
		<Route path="/shipping_payment/:Type/:Book_Id/:Uid" component={Shipping_Payment} />
		<Route path="/payment_status/:Status" component={Shipping_Status} />
		<Route path="/payment_status/:OrderType/:Oid/:Status" component={Shipping_Status} />
		<Route path="/quick_checkout" component={Quick_Checkout} />
		<Route path="/wishlist" component={WishList} />
		<Route path="/smartcart" component={SmartCart} />
		<Route path="/:Bname/brand-details/:DType/:Bid" component={About_Brand} />
		<Route path="/:Bname/brand-details/:Bid" component={About_Brand} />
		<Route path="/advertise-with-us" component={Advertise} />
		<Route path="/site-map" component={SiteMap} />
		<Route path="/checkout-flow" component={CheckoutFlow} />
		
		
		<Route path="/web" component={Web_App} />
		<Route path="/web/home" component={Web_App} />
		<Route path="/web/aboutus" component={Web_IndexHome} />
		<Route path="/web/seed" component={Web_SeedsList} />
		<Route path="/web/seed/:Name/:Dtype" component={Web_SeedsList} />
		<Route path="web/nauplii/:Name/:Stype" component={Web_NaupliiDeals} />
		<Route path="/web/sdetails/:BrandName/:Sid" component={Web_Seed_Details} />
		<Route path="/web/pdeals/brands/:BrandName/:Bid" component={Web_ProductDetails} />
		<Route path="/web/pdeals/:BrandName/:Type/:DType" component={Web_ProductDetails} />
		<Route path="/web/pdeals/:BrandName/:CatName/:Tid/:Type/:DType(/:Dids)" component={Web_ProductDetails} />
		{/*<Route path="/web/pdeals/:NewType/:CatName/:Tid" component={Web_ProductDetails} />*/}
		<Route path="/web/pdetails/:BrandName/:CatName/:Title/:Pid/:Did" component={Web_ProductFullDetails} />
		<Route path="/web/pdetails/:BrandName/:CatName/:Bname/:Title/:Pid/:Did" component={Web_ProductFullDetails} />
		<Route path="/web/subdeals/:BrandName/:CatName/:ProName/:Pid" component={Web_SubDeals} />
		<Route path="/web/subdeals/:BrandName/:CatName/:ProName/:Pid/type/:DType" component={Web_SubDeals} />
		<Route path="/web/subdeals/:BrandName/:CatName/:DType/:ProName/:Pid" component={Web_SubDeals} />
	 	<Route path="/web/subdeals/:BrandName/:Pid/:DType" component={Web_SubDeals} />
	 	<Route path="/web/enquire_now/partner/support/:Sid/:Did" component={Web_EnquireNow_Partner} />
	 	<Route path="/web/enquire/:Ltype/:Sid/:Did" component={Web_EnquireNow} />
		<Route path="/web/customer_care" component={Web_CustomerCare} />
		<Route path="/web/customer_care_seller" component={Web_CustomerCare_Seller} />
		<Route path="/web/login(/:redirectPath)" component={Web_Registration} />
		<Route path="/web/account" component={Web_Login} />
		<Route path="/web/forgot" component={Web_Forgot} />
		<Route path="/web/verify" component={Web_verifyOtp} />
		<Route path="/web/signup" component={Web_Signup} />
		<Route path="/web/reset" component={Web_Reset} />
		<Route path="/web/ab_login" component={Web_Ab_Login} />
		<Route path="/web/otpverify" component={Web_Otpverify} />
		<Route path="/web/coupon/details/:Cid" component={Web_Coupon_Details} />
		<Route path="/web/profile" component={Web_Profile} />
		<Route path="/web/mobile" component={Web_MobileNumber} />
		<Route path="/web/mobile/verify_otp" component={Web_MobVerifyOtp} />
		<Route path="/web/offers/deals/:Tid/:Type/:DType" component={Web_OffersDetails} />
		<Route path="/web/offerszone" component={Web_PromoOffersZone} />
		<Route path="/web/mycart" component={Web_MyCart} />
		<Route path="/web/blocks" component={WebdealBlocks} />
		<Route path="/web/promotional_offers" component={Web_AllPromoOffers} />
		<Route path="/web/checkout" component={Web_Checkout} />
		<Route path="/web/status/:Type" component={Web_Order_aborted} />
		<Route path="/web/status/:book_id/:type/:Uid" component={Web_Order_response} />
		<Route path="/web/downloads" component={Web_downloads} />
		<Route path="/web/shipping_payment/:Type/:Book_Id/:Uid" component={Web_Shipping_Payment} />
		<Route path="/web/payment_status/:Status" component={Web_Shipping_Status} />
		<Route path="/web/payment_status/:OrderType/:Oid/:Status" component={Web_Shipping_Status} />
		<Route path="/web/order_details/:OrderType/:Oid" component={Web_Order_Details} />
		<Route path="/web/viewrating/:Bid" component={Web_View_Rating} />
		<Route path="/web/viewrating/:Product/:Bid" component={Web_View_Rating} />
		<Route path="/web/giverating/:Bid" component={Web_GiveRatings} />
		<Route path="/web/giverating/:Product/:Bid" component={Web_GiveRatings} />
		<Route path="/web/myorders" component={Web_My_Orders} />
		<Route path="/web/order_status/:Type" component={Web_My_Order_aborted} />
		<Route path="/web/quickcart" component={Web_QuickCart} />
		<Route path="/web/quick_checkout" component={Web_Quick_Checkout} />
		<Route path="/web/stores/:StoreType/:ID" component={Web_Store_Deals} />
		<Route path="/web/stores/:StoreType" component={Web_Store_Deals} />
		{/*<Route path="/web/ad-banners/:StoreType" component={StoreDeals} />*/}
		<Route path="/web/ad-banners/:StoreType" component={Web_Store_Deals} />
		<Route path="/web/change_number" component={Web_Change_Number} />
		<Route path="/web/verify_otp" component={Web_ChangeVerifyOtp} />
		<Route path="/web/share_earn" component={Web_Share_Earn} />
		<Route path="/web/myaquacash" component={Web_MyAquaCash} />
		<Route path="/web/notifications" component={Web_Notifications} />
		<Route path="/web/offer/:Oid/details" component={Web_PromoOfr_Details} />
		<Route path="/web/promotions" component={WebPromotions} />
		<Route path="/web/smartcart" component={Web_SmartCart} />
		<Route path="/web/wishlist" component={Web_WishList} />
		<Route path="/web/:Bname/brand-details/:DType/:Bid" component={Web_About_Brand} />
		<Route path="/web/:Bname/brand-details/:Bid" component={Web_About_Brand} />
		<Route path="/web/pdeals/:Type/:Tid" component={Web_Partner_Deals} />
		<Route path="/web/advertise-with-us" component={Web_Advertise} />
		<Route path="/web/site-map" component={Web_Site_Map} />
		<Route path="/web/checkout-flow" component={Web_Site_CheckoutFlow} />
		<Route path='*' component={NotFound} />
	</Router>
</Provider>,	
  document.getElementById('root')
);


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/